import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import preventReClick from './store/preventReClick'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "lib-flexible"
import VueClipboard from 'vue-clipboard2'

import modal from '@/utils/modal'
Vue.prototype.$modal = modal

Vue.config.productionTip = false
Vue.use(ElementUI,{ size: 'small'})
Vue.use(preventReClick)
Vue.use(VueClipboard)
ElementUI.Dialog.props.closeOnClickModal.default = false
import '@/permission.js'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
